import React, { FC } from "react";
import { getSauce } from "../../__generated__/getSauce";
import styled from "styled-components";
import { IngredientWithPrice } from "./ProductCard";
import { easeOut } from "../styles/atoms";

const PizzaSauce: FC<{
  data: getSauce;
  variantName: string;
  onSelect: (variant?: IngredientWithPrice) => void;
}> = ({ data, variantName, onSelect }) => {
  if (
    !data ||
    data?.shop?.collections?.length < 1 ||
    data?.shop?.collections[0]?.products?.length < 1
  ) {
    return null;
  }

  return (
    <>
      <Label>
        Полить соусом <span>Новинка</span>
      </Label>
      <List>
        {data?.shop?.collections[0]?.products?.map((product) => (
          <li key={product.id}>
            <Item
              className={
                product.variants[0]?.name === variantName ? "active" : ""
              }
              onClick={() => {
                const variant =
                  variantName === product.variants[0]?.name
                    ? null
                    : {
                        amount: 1,
                        id: product.variants[0].id,
                        name: product.variants[0].name,
                        price: product.variants[0].price,
                      };

                onSelect(variant);
              }}
            >
              <img src={product.images[0]?.url} key={product.images[0]?.id} />
              <Info>
                <Price>+{product.variants[0]?.price}₽ </Price>
                <Name>{product.variants[0]?.name}</Name>
              </Info>
            </Item>
          </li>
        ))}
      </List>
    </>
  );
};

const Label = styled.p`
  font-weight: bold;
  font-size: 16px;
  margin: 0;
  position: relative;
  width: fit-content;

  span {
    position: absolute;
    top: 0.25rem;
    left: calc(100% + 0.8125rem);
    display: block;
    color: #fff;
    font-size: 0.625rem;
    font-weight: 700;
    line-height: 1.8;
    text-transform: uppercase;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: -0.375rem;
      right: -0.375rem;
      border-radius: 0.3125rem;
      background: #ff8021;
      box-shadow: 0px 0.1875rem 0.5625rem 0px rgba(255, 128, 33, 0.31);
      z-index: -1;
    }
  }
`;

const List = styled.ul`
  margin: 1rem 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 0.625rem;
`;

const Price = styled.p`
  margin: 0;
  color: #818181;
  font-size: 0.75rem;
  line-height: 1.5;

  transition-property: color;
  ${easeOut};
`;

const Name = styled.p`
  margin: 0.3125rem 0 0;
  color: #000;
  font-size: 1.375rem;
  line-height: 1.2;

  transition-property: color;
  ${easeOut};
`;

const Item = styled.button`
  background: #f5f5f5;
  border: none;
  border-radius: 0.625rem;
  display: flex;
  padding: 0.8125rem;
  align-items: center;
  gap: 0.8125rem;
  cursor: pointer;
  transition-property: background, box-shadow;
  ${easeOut};

  img {
    width: 2.75rem;
    height: 2.75rem;
    object-fit: cover;
  }

  &.active {
    box-shadow: 0px 6px 12px rgba(128, 168, 18, 0.430565);
    background: #78b833;

    & ${Price}, ${Name} {
      color: #ffffff;
    }
  }
`;

const Info = styled.div`
  text-align: left;
`;

export default PizzaSauce;
